import { SnackbarProvider } from 'notistack';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import FlashSnackbars from '@/components/FlashSnackbars';
import DrawerContextProvider from '@/contexts/DrawerContext';

function Providers({ children }: { children: React.ReactNode }) {
  return (
    <>
      <SnackbarProvider>
        <FlashSnackbars />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DrawerContextProvider>{children}</DrawerContextProvider>
        </LocalizationProvider>
      </SnackbarProvider>
    </>
  );
}

export default Providers;
